import { useState, useEffect } from 'react';
import * as Sentry from '@sentry/react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import Login from './components/Login';
import Documents from './components/Documents';
import GoalAnimation from './components/GoalAnimation';
import AdminLogin from './components/AdminLogin';
import AdminPanel from './components/AdminPanel';
import './App.css';


function AdminPage() {
  const [authed, setAuthed] = useState(!!localStorage.getItem('adminToken'));

  if (!authed) {
    return <AdminLogin onLoginSuccess={() => setAuthed(true)} />;
  }

  return <AdminPanel onLogout={() => setAuthed(false)} />;
}

function PortalPage() {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);
  const [showGoalAnimation, setShowGoalAnimation] = useState(false);

  useEffect(() => {
    const token = localStorage.getItem('token');
    const savedUser = localStorage.getItem('user');
    
    if (token && savedUser) {
      try {
        setUser(JSON.parse(savedUser));
      } catch {
        localStorage.removeItem('token');
        localStorage.removeItem('user');
      }
    }
    
    setLoading(false);
  }, []);

  // Identifica o conselheiro logado no Sentry. Um unico efeito cobre todos
  // os caminhos que mexem em `user` (login, restauracao de sessao no boot e
  // logout), em vez de espalhar chamadas por cada um deles.
  useEffect(() => {
    if (user) {
      Sentry.setUser({ id: user.cpf, email: user.email, username: user.nome });
    } else {
      Sentry.setUser(null);
    }
  }, [user]);

  const handleLoginSuccess = (userData) => {
    setShowGoalAnimation(true);
    setTimeout(() => {
      setUser(userData);
      setShowGoalAnimation(false);
    }, 4000);
  };

  const handleGoalComplete = () => {};

  const handleLogout = () => {
    setUser(null);
  };

  if (loading) {
    return (
      <div className="app-loading">
        <div className="loading-spinner"></div>
        <p>Carregando...</p>
      </div>
    );
  }

  return (
    <>
      {showGoalAnimation && <GoalAnimation onComplete={handleGoalComplete} userName={user?.nome || 'Conselheiro'} />}
      {!showGoalAnimation && (
        <>
          {user ? (
            <Documents user={user} onLogout={handleLogout} />
          ) : (
            <Login onLoginSuccess={handleLoginSuccess} />
          )}
        </>
      )}
    </>
  );
}

function App() {
  return (
    <BrowserRouter>
      <div className="app">
        <Routes>
          <Route path="/admin" element={<AdminPage />} />
          <Route path="/*" element={<PortalPage />} />
        </Routes>
      </div>
    </BrowserRouter>
  );
}

export default App;
